module.exports = __webpack_public_path__ + "static/media/checkmark.ce9f3188.svg";